import React from 'react';

const Dashboard: React.FC = () => <h1>Dashboard</h1>;

export default Dashboard;
